import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const ImageWithFooterCardStyles = makeStyles((theme) => ({
  linkContainer: {
    textDecoration: "none",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%"
  },
  container: {
    backgroundColor: COLORS.LIGHT_GRAY,
    padding: 0,
    margin: "0",
    border: `3px solid ${COLORS.LIGHT_GRAY}`,
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    height: "100%",
    width: "100%",
    overflow: "hidden"
  },
  imageContainer: {
    flexShrink: 0,
    width: "100%",
    "& img": {
      width: "100%",
      height: "auto",
      display: "block"
    }
  },
  footer: {
    color: COLORS.DARK_GRAY_2,
    textAlign: "left",
    padding: "20px 10px",
    backgroundColor: COLORS.WHITE,
    borderRadius: "0 0 16px 16px",
    flex: 1,
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column"
  },
  source: {
    marginTop: "auto",
    paddingTop: "12px",
    display: "flex",
    alignItems: "center",
    gap: "6px"
  },
  sourceText: {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  launchIcon: {
    opacity: .5,
    fontSize: "85%",
    color: "inherit",
    flexShrink: 0
  }
}));

export default ImageWithFooterCardStyles;
